<!--
  ClientsFilterChips.vue -- the filter chips on the workspace list.

  Card: 2026-06-13 design bundle implementation -- https://trello.com/c/hYlwyKYT

  Chip semantics owned by the parent + the Pinia store; this component
  is presentation only.

  Chip labels are matter-of-fact and singular ("Issues" not "Has
  issues"). The count rides in parens so the Distributor can
  triage the queue at a glance: "Issues (3)" means there are three
  rows the chip filter will surface.
-->
<template>
    <div class="cfc" role="tablist">
        <button
            v-for="chip in CHIPS"
            :key="chip.key"
            type="button"
            class="cfc__chip"
            :class="{ 'cfc__chip--active': chip.key === filter }"
            role="tab"
            :aria-selected="chip.key === filter ? 'true' : 'false'"
            :data-testid="`clients-workspace-chip-${chip.key}`"
            @click="$emit('change', chip.key)"
        >
            <span class="cfc__label">{{ chip.label }}</span>
            <span
                v-if="typeof counts[chip.key] === 'number'"
                class="cfc__count"
                :data-testid="`clients-workspace-chip-count-${chip.key}`"
                >({{ counts[chip.key] }})</span
            >
        </button>
    </div>
</template>

<script>
const CHIPS = [
    { key: 'issues', label: 'Issues' },
    { key: 'onboarding', label: 'Onboarding' },
    { key: 'active', label: 'Active' },
    // "Inactive" filters on the LIFECYCLE status (the soft-delete state),
    // distinct from the "Active"/"Quiet" ACTIVITY chips above/below.
    { key: 'inactive', label: 'Inactive' },
    { key: 'quiet', label: 'Quiet' },
    { key: 'all', label: 'All' },
]

export default {
    name: 'ClientsFilterChips',
    props: {
        filter: { type: String, default: 'all' },
        counts: {
            type: Object,
            default: () => ({}),
        },
    },
    emits: ['change'],
    data() {
        return { CHIPS }
    },
}
</script>

<style scoped>
.cfc {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
}
.cfc__chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 12px;
    border: 1px solid var(--tf-border, #d0d4dc);
    border-radius: 999px;
    background: var(--tf-bg, #fff);
    color: var(--tf-fg-1);
    font-size: 13px;
    cursor: pointer;
}
.cfc__chip:hover {
    background: var(--tf-surface-alt, #f4f5f7);
}
.cfc__chip--active {
    background: var(--tf-fg-1, #111);
    color: var(--tf-bg, #fff);
    border-color: var(--tf-fg-1, #111);
}
.cfc__count {
    font-variant-numeric: tabular-nums;
    opacity: 0.85;
}
</style>
